import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ensUri, marketUri } from "../constants/base.constant";

export const ensClient = new ApolloClient({ uri: ensUri, cache: new InMemoryCache() });
export const marketClient = new ApolloClient({ uri: marketUri, cache: new InMemoryCache() });
